module.exports = function isFunction(x) {
  return typeof x === 'function';
};


//////////////////
// WEBPACK FOOTER
// ../~/tcomb/lib/isFunction.js
// module id = 89
// module chunks = 1